module.exports = __webpack_public_path__ + "static/media/x-icon.df88e86a.svg";